import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Target, Users, Zap } from 'lucide-react';

const icons = [Target, Users, Zap];
const valueKeys = ['v1', 'v2', 'v3'];

const About = () => {
  const { t } = useTranslation();
  return (
    <section id="about" data-testid="about-section" className="py-14 lg:py-20 bg-[#FAF8F5] relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none select-none overflow-hidden">
        <motion.div className="absolute whitespace-nowrap" style={{ top: '10%' }}
          animate={{ x: ['5%', '-25%'] }} transition={{ duration: 28, repeat: Infinity, ease: 'linear' }}>
          <span className="text-[16vw] font-bold text-[#1A1816]/[0.025] tracking-[-0.05em] font-sans leading-none">
            ABOUT&nbsp;&nbsp;&nbsp;HORIZON&nbsp;&nbsp;&nbsp;ABOUT&nbsp;&nbsp;&nbsp;HORIZON
          </span>
        </motion.div>
      </div>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-[1px] bg-[#C9A96E]" />
              <span className="text-[9px] font-semibold tracking-[0.3em] uppercase text-[#8A857D]">{t('nav.about')}</span>
            </div>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-sans font-bold text-[#1A1816] leading-tight mb-6">
              {t('about.title1')}<br /><span className="font-serif italic text-[#C9A96E]">{t('about.title2')}</span>
            </h2>
            <p className="text-sm sm:text-base text-[#8A857D] leading-relaxed mb-4">
              {t('about.desc1')}
            </p>
            <p className="text-sm sm:text-base text-[#8A857D] leading-relaxed">
              {t('about.desc2')}
            </p>
          </motion.div>
          <div className="space-y-6">
            {valueKeys.map((vk, i) => {
              const Icon = icons[i];
              return (
                <motion.div key={vk} data-testid={`about-value-${i}`}
                  className="flex gap-5 p-5 border border-[#1A1816]/5"
                  initial={{ opacity: 0, x: 20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}>
                  <Icon className="w-6 h-6 text-[#C9A96E] flex-shrink-0 mt-0.5" strokeWidth={1.5} />
                  <div>
                    <h3 className="text-sm font-semibold text-[#1A1816] mb-1">{t(`about.${vk}_title`)}</h3>
                    <p className="text-sm text-[#8A857D] leading-relaxed">{t(`about.${vk}_desc`)}</p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
